import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { Skeleton, Tooltip } from '@mui/material';
import StatusBadge from 'ui-component/StatusBadge';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import usePermissions from 'hooks/usePermissions';
import useIsMobile from 'utils/isMobileUtils';


const InvoiceComponent = ({ details, isPageLoading, viewedBy = 'ADMIN' }) => {
    const [allPermissions, hasEveryPermission] = usePermissions();
    const history = useNavigate();
    const isMobile = useIsMobile();
    
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
    const [defaultCurrency, setDefaultCurrency] = useState(details?.invoice?.currency || 'usd');
    
    const handleOpenNewTab = (pageModule, id, ref = null) => {
        let url = '';
        if (pageModule == 'products') {
            url = viewedBy === 'ADMIN' ? `/products/${id}` : `/client/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = viewedBy === 'ADMIN' ? `/sales/sales-orders/${id}?ref=${ref}` : `/client/sales-orders/${id}?ref=${ref}`;
        } else if (pageModule == 'invoices') {
            url = viewedBy === 'ADMIN' ? `/sales/invoices/${id}?ref=${ref}` : `/client/invoices/${id}?ref=${ref}`;
        } else if (pageModule == 'quotations') {
            url = viewedBy === 'ADMIN' ? `/sales/quotations/${id}?ref=${ref}` : `/client/quotations/${id}?ref=${ref}`;
        }
        if (url) {
            history(url);
        }
    };

    return (
        !isMobile ? (
            <div style={{ padding: '0px 20px 20px 16px' }}>
        
                <div className="row mb10">
                    <div className="col-12">
                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>
                            {
                                isPageLoading ? (
                                    <div style={{ width: '100px', marginBottom: '3px' }}>
                                        <Skeleton variant="rounded" width={'100%'} height={21}></Skeleton>
                                    </div>
                                ) : (
                                    `Invoice`
                                )
                            }
                            
                        </h2>
                    </div>
                </div>

                <div className="row">
                    {
                        viewedBy === 'ADMIN' ? (
                            <>
                                <div className="col-md-2 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Invoice #`
                                        )
                                    }
                                </div>
                                <div className="col-md-4 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Customer`
                                        )
                                    }
                                </div>
                                <div className="col-md-2 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Date`
                                        )
                                    }
                                </div>
                                <div className="col-md-2 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Status`
                                        )
                                    }
                                </div>
                                <div className="col-md-2 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Total`
                                        )
                                    }
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-4 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Invoice #`
                                        )
                                    }
                                </div>
                                <div className="col-md-4 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Date`
                                        )
                                    }
                                </div>
                                <div className="col-md-4 font600">
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `Status`
                                        )
                                    }
                                </div>
                            </>
                        )
                    }
                </div>

                <hr className="mt8 mb8" />

                <div className="row">
                    {
                        viewedBy === 'ADMIN' ? (
                            <>
                                <div className="col-md-2 d-flex align-items-center">
                            
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            <div
                                                className={`${hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : '' }`}
                                                onClick={() => {
                                                    if (hasEveryPermission(['View Estimation Details (Page)'])) {
                                                        handleOpenNewTab('invoices', details?.invoice?.id, details?.invoice?.ref);
                                                    }
                                                }}
                                            >
                                                {details?.invoice?.invoice_number}
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                            
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '200px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            <div
                                                className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : '' }`}
                                                onClick={() => {
                                                    if (hasEveryPermission(['View Contact Details (Page)'])) {
                                                        handleOpenNewTab('contacts', details?.invoice?.customer?.id)
                                                    }
                                                }}
                                            >
                                                {details?.invoice?.customer?.name}
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                            
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `${moment(details?.invoice?.date).format(CommonDateOnlyFormat)}`
                                        )
                                    }
                                </div>
                                <div className="col-md-2 ">
                                    <div style={{ width: '90px' }}>
                                    
                                        {
                                            isPageLoading ? (
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            ) : (
                                                <StatusBadge itemStatus={details?.invoice?.status} />
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                            
                                    {
                                        isPageLoading ? (
                                                <div style={{ width: '100px', marginBottom: '3px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                                </div>
                                        ) : (
                                            <div className="flex gap-1 w-full">
                                                
                                                <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0'}` }}>
                                                    {getCurrencySymbolV2(selectedCurrency, details?.invoice?.currency, '11px', '11px')}
                                                </div>
                                                <div>
                                                    {details?.invoice?.converted_currency_total ? numberFormatter.format(details?.invoice?.converted_currency_total[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-4 d-flex align-items-center">
                            
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            <div
                                                className={`text-primary cursor-pointer`}
                                                onClick={() => {
                                                    handleOpenNewTab('invoices', details?.invoice?.invoice_number, details?.invoice?.ref);
                                                }}
                                            >
                                                {details?.invoice?.invoice_number}
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                            
                                    {
                                        isPageLoading ? (
                                            <div style={{ width: '100px', marginBottom: '3px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            </div>
                                        ) : (
                                            `${moment(details?.invoice?.date).format(CommonDateOnlyFormat)}`
                                        )
                                    }
                                </div>
                                <div className="col-md-4 ">
                                    <div style={{ width: '90px' }}>
                                    
                                        {
                                            isPageLoading ? (
                                                <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
                                            ) : (
                                                <StatusBadge itemStatus={details?.invoice?.status} />
                                            )
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
                <hr className="mt8 mb8" />
            </div>
        ) : (
            // --- MOBILE VERSION FROM ESTIMATION ---
            <div
                style={{ display: 'flex', flexDirection: 'column' }}
                onClick={() => {
                    if (viewedBy === 'ADMIN') {
                        handleOpenNewTab('invoices', details?.invoice?.id, details?.invoice?.ref);
                    } else {
                        handleOpenNewTab('invoices', details?.invoice?.invoice_number, details?.invoice?.ref);
                    }
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <h2 className="d-flex font500" style={{ fontSize: '17px', marginBottom: 0 }}>
                        Invoice
                    </h2>
                    <div>
                        <div style={{ width: '90px' }}>
                            <StatusBadge itemStatus={details?.invoice?.status} />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 5, alignItems: 'center', fontWeight: 500, fontSize: 13 }}>
                        Invoice #:
                        <div
                            className={`text-primary cursor-pointer`}
                            onClick={() => {
                                if (viewedBy === 'ADMIN') {
                                    handleOpenNewTab('invoices', details?.invoice?.id, details?.invoice?.ref);
                                } else {
                                    handleOpenNewTab('invoices', details?.invoice?.invoice_number, details?.invoice?.ref);
                                }
                            }}
                        >
                            {details?.invoice?.invoice_number}
                        </div>
                    </div>
                    <div>
                        {moment(details?.invoice?.date).format(CommonDateOnlyFormat)}
                    </div>
                </div>
                {
                    viewedBy === 'ADMIN' && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 500, fontSize: 13 }}>
                            <div
                                className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                onClick={() => {
                                    if (hasEveryPermission(['View Contact Details (Page)'])) {
                                        handleOpenNewTab('contacts', details?.invoice?.customer?.id, details?.invoice?.ref);
                                    }
                                }}
                            >
                                {details?.invoice?.customer?.name}
                            </div>
                            <div style={{ fontWeight: 500 }}>
                                    
                                <div className="flex gap-1 w-full">
                                    
                                    <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0'}` }}>
                                        {getCurrencySymbolV2(selectedCurrency, details?.invoice?.currency, '11px', '11px')}
                                    </div>
                                    <div>
                                        {details?.invoice?.converted_currency_total ? numberFormatter.format(details?.invoice?.converted_currency_total[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    );
};

export default InvoiceComponent;
